export const esmGraphNodes = [
    { 
        id: 'hospital', 
        label: 'Bệnh Viện', 
        labelEn: 'Hospitals',
        brands: ['', '', '', '', '']
    },
    { 
        id: 'insurance', 
        label: 'Bảo hiểm', 
        labelEn: 'Insurance',
        brands: ['', '', '']
    },
    { 
        id: 'service', 
        label: 'Các Ngành Dịch vụ', 
        labelEn: 'Service Industries',
        brands: ['', '', '', '']
    },
    { 
        id: 'bank', 
        label: 'Ngân hàng', 
        labelEn: 'Banks',
        brands: ['', '']
    },
    { 
        id: 'supply', 
        label: 'Chuỗi cung ứng thiết bị Y Tế', 
        labelEn: 'Medical Equipment Supply Chain',
        brands: ['', '', '']
    },
    { 
        id: 'clinic', 
        label: 'Phòng khám', 
        labelEn: 'Clinics',
        brands: ['', '', '', '']
    }
];

export const esmBenefitsData = {
    title: 'Lợi Ích Chuỗi giữa Khách hàng – Bệnh viện – Phòng khám – Bác Sĩ – Nhà thuốc',
    titleEn: 'Chain Benefits between Customers - Hospitals - Clinics - Doctors - Pharmacies',
    hospital: {
        title: 'BỆNH VIỆN',
        titleEn: 'HOSPITALS',
        items: [
            'Tiếp cận thông tin bệnh nhân, sàng lọc và phân luồng bệnh nhân...',
            'Mở rộng tệp khách hàng',
            'Cung cấp các gói khám, giá gói khám và dịch vụ mở rộng, thăm khám định kỳ',
            'Lên lịch và điều phối nhân sự chủ động',
            'Quản lý khám và thống kê báo cáo trên biểu đồ công nghệ',
            'Xem vị trí Bệnh viện trong bán kính gần nhất để đăng ký khám bệnh'
        ]
    },
    clinic: {
        title: 'PHÒNG KHÁM',
        titleEn: 'CLINICS',
        items: [
            'Tiếp cận thông tin bệnh nhân, sàng lọc và phân luồng bệnh nhân...',
            'Mở rộng tệp khách hàng theo chuyên ngành phòng khám',
            'Cung cấp các gói khám, giá gói khám và dịch vụ .....',
            'Lên lịch tiếp nhận và tư vấn khách hàng',
            'Xem vị trí Phòng khám trong bán kính gần nhất để đăng ký khám bệnh'
        ]
    },
    doctor: {
        title: 'BÁC SĨ',
        titleEn: 'DOCTORS',
        items: [
            'Tiếp cận sớm thông tin bệnh nhân',
            'Tham chiếu thông tin một cách toàn diện vào hệ thống',
            'Tiếp cận hệ thống khám chữa bệnh y tế thông minh',
            'Tư vấn và chuẩn đoán bệnh'
        ]
    },
    patient: {
        title: 'BỆNH NHÂN',
        titleEn: 'PATIENTS',
        items: [
            'Lựa chọn Bệnh viện và Bác sĩ theo tuyến, vị trí, chuyên khoa',
            'Gói khám, giá gói khám, hẹn và nhắc lịch khám, uống thuốc, tái khám',
            'Tư vấn sàng lọc trước và sau viêm',
            'Phát thuốc tận nơi',
            'Xem vị trí Nhà thuốc trong bán kính gần nhất để mua sản phẩm Dược',
            'Tải hồ sơ bệnh án, KQ xét nghiệm',
            'Theo dõi bệnh từ xa',
            'Thanh toán điện tử...'
        ]
    },
    insurance: {
        title: 'BẢO HIỂM',
        titleEn: 'INSURANCE',
        items: [
            'Kết nối trực tiếp hệ thống viện phí để bảo lãnh viện phí nhanh chóng',
            'Rút ngắn thời gian xử lý hồ sơ bồi thường bảo hiểm',
            'Đa dạng hóa các gói bảo hiểm sức khỏe cá nhân hóa theo hồ sơ bệnh án'
        ]
    },
    service: {
        title: 'CÁC NGÀNH DỊCH VỤ',
        titleEn: 'SERVICE INDUSTRIES',
        items: [
            'Hỗ trợ các dịch vụ xe cấp cứu, vận chuyển bệnh nhân',
            'Dịch vụ y tế tại nhà (điều dưỡng, chăm sóc người cao tuổi, xét nghiệm)',
            'Cung cấp giải pháp công nghệ, marketing, quản lý vận hành y tế'
        ]
    },
    bank: {
        title: 'NGÂN HÀNG',
        titleEn: 'BANKS',
        items: [
            'Tích hợp cổng thanh toán trực tuyến, thanh toán không tiền mặt',
            'Hỗ trợ tài chính, cung cấp các gói tín dụng cho bệnh viện, phòng khám',
            'Cung cấp dịch vụ trả góp viện phí cho bệnh nhân'
        ]
    },
    supply: {
        title: 'CHUỖI CUNG ỨNG THIẾT BỊ Y TẾ',
        titleEn: 'MEDICAL SUPPLY CHAIN',
        items: [
            'Cung cấp vật tư, trang thiết bị y tế chính hãng, minh bạch',
            'Đồng bộ hệ thống tồn kho, tự động cảnh báo khi vật tư cạn kiệt',
            'Đảm bảo chất lượng và giá cả cạnh tranh qua đấu thầu trực tuyến'
        ]
    }
};
